<template>
  <div>
    <div class="app-ini">
      <!-- SETA O TITULO DA PAGINA -->
      <div class="boasvindas">
        <div class="destaque-1">
          Seja Bem Vindo(a) ao Rotina Fácil  
        </div>
        <div>
          <a href='http://www.rotinafacil.com.br' target='_blank' title="Rotina Fácil - O Software Amigo Do Empresário."><img @click="appInicianteAbrirImagem" src="/img/rotina_facil.png"></a>
        </div>
      </div>

      <hr/>

      <!-- SETA O PASSO 1 -->
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 1 - Como acessar:
          </div>

          <div>
            <p>
              Abaixo segue o link de acesso ao Software.
            </p>
            <p>
              Aconselhamos deixá-lo como página inicial do seu navegador ou então cadastrado nos favoritos.
            </p>
            <p>
              <a href="https://web.rotinafacil.com" target="_blank">https://web.rotinafacil.com</a>
            </p>
            <p>
              Ná pagina que abrir coloque a sua conta e senha.
            </p>
            <p>
              Conta: <span v-html="$store.state.token.conta"></span>
            </p>
            <p>
              Utilize sempre os navegadores Google Chrome ou Mozilla Firefox.
            </p>
          </div>
        </div>

        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img1.jpg"/>
        </div>
      </div>

      <hr/>

      <!-- SETA O PASSO 2 -->
      <div class="app-ini-passo">
        <div>
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 2 - Pacotes:
          </div>

          <div class="imagem">
            <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img2.jpg"/>
          </div>
        </div>

        <div class="titulo">
          <br/>
          <div>
            <p>
              Você pode adicionar ou remover pacotes sempre que desejar (para remoção é necessário aguardar pelo menos 30 dias).
            </p>
            <p>
              Esta opção sempre esta disponível no rodapé do sistema, ou na Engrenagem -> Meu Cadastro -> Pacotes.
            </p>
          </div>
        </div>
      </div>
      <div class="app-ini-passo">
        <div class="titulo">
          <div>
            <p>
              Clicando nela temos a coluna da esquerda (com todos os pacotes disponíveis para contratação) e a coluna da direita (com todos os pacotes contratados).
            </p>
            <p>
              No período de testes você pode adicionar ou remover estes pacotes e já consultar os valores a serem pagos nesta mesma tela.
            <p>
            <p>
              Após a contratação é possível testar novos pacotes por 10 dias.
            </p>
          </div>
        </div>

        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img3.jpg"/>
        </div>        
      </div>

      <hr/>

      <!-- SETA O PASSO 3 -->
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 3 - Menu:
          </div>
          <div>
            <div class="imagem">
              <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img4.jpg"/>
            </div>
          </div>
        </div>

        <div class="titulo">
          <br/>
          <div>
            <p>
              Do lado esquerdo existe o Menu Principal. Passando o mouse ou clicando sobre ele todos os pacotes disponíveis na sua licença de uso estarão aparecendo.
            </p>
            <p>
              Exemplo: Menu -> Contatos -> Gerenciar.
            </p>
          </div>
        </div>
      </div>
      <div class="app-ini-passo">
        <div class="titulo">
          <br/>
          <div>
            <p>
              É possível adicionar os recursos que mais usa na barra superior preta.   
            </p>
            <p>
              Para isto basta clicar na estrela no Menu Principal assim você economiza tempo.
            </p>
            <p>
              Para remover o Favorito ir no menu novamente e desmarcar a estrela.
            </p>
          </div>
        </div>
        <div class="titulo">
          <div class="imagem">
            <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img6.jpg"/>
          </div>
        </div>
      </div>
      <div class="app-ini-passo">
        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img5.jpg"/>
        </div>

        <div class="titulo">
          <div>
            <p>
              Do lado direito temos a engrenagem. 
            </p>
            <p>
              Acessando as opções dela é possível atualizar o seu cadastro, gerenciar os usuários existentes, inserir o certificado digital, logotipo da sua empresa, vincular contas de e-mail dentre outros.
            </p>
          </div>
        </div>
      </div>

      <hr/>

      <!-- SETA O PASSO 4 -->
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 4 - Suporte:
          </div>

          <div>
            <p>
              Nosso atendimento é de segunda a sexta (exceto feriados) das 08:30 às 12:00 e 13:30 as 18:00. 
            </p>
            <p>
              Você pode entrar em contato conosco por telefone (41) 3076-7488 ou pelo whatsapp (mesmo número fixo). 
            </p>
            <p>
              Esta informação também fica sempre disponível no rodapé do sistema. 
            </p>
            <p>
              Clicando no ícone do whatsapp já abre direto seu whatsapp web para conversar conosco.
            </p>
          </div>
        </div>

        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img7.jpg"/>
        </div>
      </div>
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="imagem">
            <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img8.jpg"/>
          </div>
        </div>

        <div class="titulo">
          <br/>
          <div>
            <p>
              Temos também a documentação do sistema que pode ser acessada no ícone de pergunta localizado no canto superior direito. 
            </p>
            <p>
              Caso sua dúvida ainda não tenha sido respondida você pode enviar para adm@subase.com.br ou entrar em contato.
            </p>
          </div>
        </div>
      </div>

      <hr/>

      <!-- SETA O PASSO 5 -->
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 5 - Usuários adicionais:
          </div>
          <div>
            <p>
              Quando uma licença de uso é criada, ela vem com um usuário Administrador. 
            </p>
            <p>
              É possível criar usuários adicionais indo na Engrenagem -> Gerenciar Usuários. 
            </p>
            <p>
              Nesta tela você define quais permissões o novo usuário terá acesso.
            </p>
            <p>
              Após criar o usuário, informe a pessoa que irá utilizar de que ela precisa acessar o sistema pelo endereço web.rotinafacil.com e digitar a conta que será o nome que você criou @{{ $store.state.token.clu }} e a senha.
            </p>
          </div>
        </div>

        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img9.jpg"/>
        </div>
      </div>

      <hr/>

      <!-- SETA O PASSO 6 -->
      <div class="app-ini-passo">
        <div class="titulo">
          <div class="destaque-2">
            <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> 6 - Contratação / Forma de Pagamento:
          </div>
          <div>
            <p>
              Para contratar nossa solução é necessário fazer o aceite eletrônico do contrato. 
            </p>
            <p>
              É sempre bom conferir antes os Pacotes / Valores para ver se estão de acordo com a sua necessidade.
            </p>
            <p>
              Ir na Engrenagem -> Meu Cadastro. 
            </p>
            <p>
              Ir na Aba Contrato de Licença de Uso, marcar Concordo, Conferir os valores, Colocar a senha do seu usuário e clicar em Declaro que li e concordo com todos os termos descritos acima. Pode ser que nesta tela abra outra pedindo mais informações como CNPJ, CPF do responsável legal pela empresa dentre outros.
            </p>
            <p>
              Após fazer o aceite do contrato, você terá duas opções de forma de pagamento: Boleto ou Cartão de Crédito.
            </p>
            <p>
              Caso opte por Cartão de Crédito assim que aceitar aparecerá uma tela para inserir os dados do cartão.
            </p>
            <p>
              Caso opte por boleto basta fechar esta janela e você estará recebendo o boleto em até 24 horas úteis.
            </p>
            <p>
              O primeiro vencimento ocorre 8 dias após o aceite, porém para os casos de emissão de nota é necessário quitar o boleto assim que precisar emitir no ambiente de produção da Sefaz.
            </p>
            <p>
              Cancelamento: Não existe multa ou fidelidade, porém se tiver algum boleto em aberto é necessário quitá-lo. 
            </p>
            <p>
              Caso opte por cancelar é necessário criar um chamado (Engrenagem -> Suporte. Aba Chamados -> Novo Chamado) informando o desejo de cancelar e também o motivo para formalizar o pedido.
            </p>
          </div>
        </div>

        <div class="imagem">
          <img @click="appInicianteAbrirImagem" src="https://s3.sa-east-1.amazonaws.com/arq.rotinafacil.com/iniciante/img10.jpg"/>
        </div>
      </div>
    </div>

    <!-- 
    :escDisabled="cpntEscDisabled"
    :moveDisabled="cpntMoveDisabled"
    @hide="armArquivoFileIconeAbrirVisualizacao"
     -->
    <vue-easy-lightbox v-if="lightbox !== ''"
    :visible="true"
    :imgs="lightbox"
    @hide="appInicianteFecharImagem"
  ></vue-easy-lightbox>
  </div>
</template>

<style>
.destaque-1 {
  font-size: 30px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
.destaque-2 {
  font-size: 16px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
  .app-ini {
    margin: 0px auto;
    max-width: 700px;
    font-family: "Open Sans",sans-serif;
    font-size: 14px;
    line-height: 18px;
    color: #222;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    background: #fcfcfc;
  }

  .boasvindas {
    text-align: center;
  }
    .boasvindas > .destaque-1 {
      margin-bottom: 10px;
    }
  .app-ini-passo {
    margin-top: 10px;
  }
    .app-ini-passo > div {
      display: inline-block;
      vertical-align: top;
    }
    .app-ini-passo > div:first-child {
      margin-right: 10px;
    }
    
    .app-ini-passo > div.titulo {
      width: calc(50% - 5px);
      padding-bottom: 10px;
      text-align: justify;
    }
    .app-ini-passo > div:not(.titulo) {
      width: calc(50% - 5px);
    }
      .app-ini-passo > div > div:first-child {
        padding-bottom: 8px;
      }

.imagem {
  background: #e9e9e9;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
}
  .imagem > img {
    width: 100%;
    border-radius: 5px;
    cursor: pointer;
  }
</style>

<script>
  export default {
    components: {
      'vue-easy-lightbox': () => import('vue-easy-lightbox')
    },
    data: function () {
      return {
        time: '',
        lightbox: ''
      }
    },
    methods: {
      appInicianteAbrirImagem: function (event) {
        // SETA A IMAGEM QUE DEVE ABRIR
        this.lightbox = [ { title: '', src: event.target.src } ]

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appInicianteFecharImagem: function () {
        // SETA A IMAGEM QUE DEVE ABRIR
        this.lightbox = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
